
import axios from 'axios';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import useUtilities from '../../hooks/useUtilities';
import { SelectComponent } from './ReusableSmallComponents';
// import { CompareTwoString } from '../../Utils/utils';

const SearchCityByRegions = ({
    paysLocalisation,
    setPaysLocalisation,
    regionLocalisation,
    setRegionLocalisation,
    villeLocalisation,
    setVilleLocalisation,
    setCheckUpdateValue,
    mode,
    namePays,
    nameRegion,
    nameVille
    // dataExpert
}) => {
    SearchCityByRegions.propTypes = {
        paysLocalisation: PropTypes.any,
        regionLocalisation: PropTypes.any,
        villeLocalisation: PropTypes.any,
        setPaysLocalisation: PropTypes.func,
        setCheckUpdateValue:PropTypes.func,
        setRegionLocalisation: PropTypes.func,
        setVilleLocalisation: PropTypes.func,
        mode: PropTypes.any,
        namePays: PropTypes.any,
        nameRegion: PropTypes.any,
        nameVille: PropTypes.any,
    };

    // const role = useRole();
    // TODO don't forget to clear the data when the user leave this page ( completeProfile/preference || monCompte/Preference)
    const { remoteCountriesData, setRemoteCountriesData } = useUtilities();
    const [citiesOfSelectedRegion, setCitiesOfSelectedRegion] = useState([]);
    const [regionsOfSelectedCountry, setRegionOfSelectedCountry] = useState([]);
    const { i18n } = useTranslation();
    useEffect(() => {
        if(remoteCountriesData.length == 0){
        // * DATA HUB API: https://datahub.io/core/world-cities
            axios
                .get(
                    'https://pkgstore.datahub.io/core/world-cities/world-cities_json/data/5b3dd46ad10990bca47b04b4739a02ba/world-cities_json.json'
                )
                .then((res) => {
                    if (Array.isArray(res.data)) {
                    // setRemoteLocalisationsData(res.data);// ! 2.2 Mo ! too much
                    // * Actual Data: {country,subcountry,name(of the city),geonameid}
                    // * wanted DATA:
                    // * {[ country, regions: [ { region: '*****',
                    // *     cities: ['****', '####' ]}
                    // *    { region: '22*****',
                    // *     cities: ['*33***', '##44##' ]} ]
                    // *  ]}
                        const adaptedCountryFormat = [];
                        // Loop through each city in the input data
                        res.data.forEach(({ country, subcountry, name }) => {
                        // Index to keep track of the current country in the result array
                            let countryIndex = -1;

                            // Loop through each country in the result array to check if it already exists
                            adaptedCountryFormat.forEach((item, index) => {
                            // If the country exists in the result array, set the index
                                if (item.country === country) {
                                    countryIndex = index;
                                }
                            });

                            // If the country doesn't exist in the result array
                            if (countryIndex === -1) {
                            // Add the new country to the result array
                                adaptedCountryFormat.push({
                                    country: country,
                                    regions: [{ region: subcountry, cities: [name] }],
                                });
                            } else {
                            // Index to keep track of the current subcountry in the regions array
                                let subcountryIndex = -1;

                                // Loop through each subcountry in the regions array to check if it already exists
                                adaptedCountryFormat[countryIndex].regions.forEach(
                                    (item, index) => {
                                    // If the subcountry exists in the regions array, set the index
                                        if (item.region === subcountry) {
                                            subcountryIndex = index;
                                        }
                                    }
                                );

                                // If the subcountry doesn't exist in the regions array
                                if (subcountryIndex === -1) {
                                // Add the new subcountry to the regions array
                                    adaptedCountryFormat[countryIndex].regions.push({
                                        region: subcountry,
                                        cities: [name],
                                    });
                                } else {
                                // Add the city to the existing subcountry in the regions array
                                    adaptedCountryFormat[countryIndex].regions[
                                        subcountryIndex
                                    ].cities.push(name);
                                }
                            }
                        });
                        console.log(adaptedCountryFormat);
                        console.log('test adapted data', adaptedCountryFormat);
                        // * OLD setCountry([...new Set(res.data.map(item=>item.country))].sort());
                        setRemoteCountriesData(adaptedCountryFormat);
                    }
                })
                .catch((err) => console.log(err));
        }
    }, []);

    useEffect(() => {
        if(paysLocalisation){
            //  * load the regions data after having a selected Pays
            setRegionOfSelectedCountry(remoteCountriesData?.find((c) => c?.country === paysLocalisation)?.regions);
        }
    }, [paysLocalisation]);

    useEffect(() => {
        if(regionLocalisation && regionsOfSelectedCountry){
            //  * load the cities data after having a selected region and a list of regions already ready
            setCitiesOfSelectedRegion(regionsOfSelectedCountry?.find((r) => r?.region === regionLocalisation)?.cities);
        }
    }, [regionLocalisation, regionsOfSelectedCountry]);

    const handleChangeLocalisation = (e) => {
        // * get the name and the value of the select
        const { name, value: targetValue } = e.target;
        if (name.toLowerCase().includes('pays')) {
            //    * OLD
            // let states = remoteLocalisationsData.filter(
            //     (state) => state.country === e.target.value
            // );
            // states = [...new Set(states.map((item) => item.subcountry))];
            // states.sort();

            // * user should minimun enter smthing in the page to do 'suivant'
            // if(!CompareTwoString(value,paysLocalisation))
            //     setCheckUpdateValue(false);

            setPaysLocalisation(targetValue);
            if(setCheckUpdateValue)
                setCheckUpdateValue(false);
            //* moved to useEffect: setRegionOfSelectedCountry(remoteCountriesData?.find((c) => c?.country === targetValue)?.regions);
        } else if (name.toLowerCase().includes('region')) {
            // * OLD
            // let cities = remoteLocalisationsData.filter(
            //     (city) => city.subcountry === e.target.value
            // );
            // cities.sort();
            // cities.reverse();
            // * user should minimun enter smthing in the page to do 'suivant'
            // if(!CompareTwoString(value,regionLocalisation))
            //     setCheckUpdateValue(false);
            setRegionLocalisation(targetValue);
            if(setCheckUpdateValue)
                setCheckUpdateValue(false);
            //* moved to useEffect: setCitiesOfSelectedRegion(regionsOfSelectedCountry?.find((r) => r?.region === targetValue)?.cities);
        } else if  (name.toLowerCase().includes('ville')) {
            // * user should minimun enter smthing in the page to do 'suivant'
            // if(!CompareTwoString(value,villeLocalisation))
            //     setCheckUpdateValue(false);
            setVilleLocalisation(targetValue);
            if(setCheckUpdateValue)
                setCheckUpdateValue(false);
        }
    };

    return (
        <>
            <SelectComponent
                label={i18n.t('Pays')}
                val={paysLocalisation}
                name = {namePays ?? 'pays'}
                disabled={mode == 'readOnly' ? true : false}
                setVal={(e) => {
                    handleChangeLocalisation(e);
                }}
                listVal={remoteCountriesData}
            />
            <SelectComponent
                label={i18n.t('Région')}
                val={regionLocalisation}
                disabled={mode == 'readOnly'}
                name ={nameRegion ?? 'region'}
                setVal={(e) => {
                    handleChangeLocalisation(e);
                }}
                listVal={regionsOfSelectedCountry}
            />
            <SelectComponent
                label={i18n.t('Ville')}
                name={nameVille ?? 'ville'}
                val={villeLocalisation}
                disabled={mode == 'readOnly'}
                setVal={(e) => {
                    handleChangeLocalisation(e);
                }}
                listVal={citiesOfSelectedRegion}
            />

            {/*<ThemeProvider theme={FieldComponentFont}>
                <FormControl
                    style={{ width: '33%' }}
                    size={inputSize}
                >
                    <InputLabel>Pays</InputLabel>
                    <Select
                        name="pays"
                        value={paysLocalisation}
                        label="Pays"
                        onChange={(e) => {
                            handleChangeLocalisation(e);
                        }}
                        id="#"
                        disabled={role == 'admin' ? true : false}
                        sx={{
                            '& > :not(style)': { borderRadius: '8px' },
                        }}
                        style={{ background: 'white' }}
                    >
                        {Array.isArray(remoteCountriesData) &&
                            remoteCountriesData.map((items, i) => (
                                <MenuItem
                                    key={i}
                                    value={items?.country}
                                >
                                    {items?.country}
                                </MenuItem>
                            ))}
                    </Select>
                </FormControl>
            </ThemeProvider>
            <ThemeProvider theme={FieldComponentFont}>
                <FormControl
                    style={{ width: '33%' }}
                    size={inputSize}
                >
                    <InputLabel>Région</InputLabel>
                    <Select
                        //onChange = {(e) => handlestate(e)}
                        name="region"
                        value={regionLocalisation}
                        disabled={role == 'admin' ? true : false}
                        onChange={(e) => {
                            handleChangeLocalisation(e);
                        }}
                        label="Région"
                        id="#"
                        sx={{
                            '& > :not(style)': { borderRadius: '8px' },
                        }}
                        style={{ background: 'white' }}
                    >
                        {Array.isArray(regionsOfSelectedCountry) &&
                            regionsOfSelectedCountry.map((items, i) => (
                                <MenuItem
                                    key={i}
                                    value={items?.region}
                                >
                                    {items?.region}
                                </MenuItem>
                            ))}
                    </Select>
                </FormControl>
            </ThemeProvider>
            <ThemeProvider theme={FieldComponentFont}>
                <FormControl
                    style={{ width: '33%' }}
                    size={inputSize}
                >
                    <InputLabel>Ville</InputLabel>
                    <Select
                        //onChange = {(e) => setVille(e.target.value)}
                        name="ville"
                        value={villeLocalisation}
                        disabled={role == 'admin' ? true : false}
                        onChange={(e) => {
                            handleChangeLocalisation(e);
                        }}
                        label="Ville"
                        id="#"
                        sx={{
                            '& > :not(style)': { borderRadius: '8px' },
                        }}
                        style={{ background: 'white' }}
                    >
                        {Array.isArray(citiesOfSelectedRegion) && citiesOfSelectedRegion.sort().map((items,i) => (
                            <MenuItem
                                key={i}
                                value={items}
                            >
                                {items}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </ThemeProvider>*/}
        </>
    );
};
export default SearchCityByRegions;
